import { css } from '@emotion/react';

export const spinnerStyles = css`
  animation: lt-spin 1s linear infinite;

  @keyframes lt-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
